export type ActivityFormValues = Util.PartialPartial<Knowledge.Activity.Detail, 'id'> & {
  itemsV2?: Knowledge.Activity.Item[];
};

export type FV = ActivityFormValues;

export const defaultInitialValues: FV = {
  activityType: 'NEW_PRODUCT_ONSALE_ACTIVITY',
  activityName: '',
  activityFrom: '',
  activityTo: '',
  timeRangeScopes: undefined,
  activityPrepareFrom: undefined,
  activityPrepareTo: undefined,
  stores: [],
  items: [],
  recommendItems: [],
  itemsV2: undefined,
  maxDiscount: '',
  activityTheme: undefined,
  activityHighlight: '',
  voucherMinOrderAmount: undefined,
  multiPackThreshold: undefined,
  discountType: 'PERCENT',
  discountValue: undefined,
  promotionType: 'NO_PROMOTION',
  itemHighlights: [],
  slogans: [
    {
      item: '',
      originPrice: '',
      currentPrice: '',
    },
  ],
  liveCode: 'VIP123',
  liveCodeDiscount: undefined,
  activityVoucherType: undefined,
  voucherList: [],
};

export const createInitialValues = (partial: Partial<FV>) => {
  return {
    ...defaultInitialValues,
    ...partial,
  };
};

export const updateItemHighlightsByItems = (
  items: Knowledge.Activity.Item[],
  itemHighlights: Knowledge.Activity.ItemHighlight[],
) => {
  let changed = false;

  const next = items
    .reduce(
      (res, item) => {
        const itemNotExist = res.every(({ appliedItems }) => {
          return appliedItems.every(({ itemInternalId }) => itemInternalId !== item.itemInternalId);
        });

        if (itemNotExist) {
          res.push({
            highlight: '',
            appliedItems: [item],
          });

          changed = true;
        }

        return res;
      },
      [...itemHighlights],
    )
    .map((itemHighlight) => {
      const { appliedItems, ...others } = itemHighlight;

      const nextItems = appliedItems.filter(({ itemInternalId }) =>
        items.some((item) => item.itemInternalId === itemInternalId),
      );

      if (nextItems.length < appliedItems.length) {
        changed = true;
        return {
          ...others,
          appliedItems: nextItems,
        };
      }

      return itemHighlight;
    })
    .filter(({ appliedItems }) => appliedItems.length > 0);

  return changed ? next : itemHighlights;
};
